module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/browserify-sign/algos.js
// module id = 647
// module chunks = 2